import { useGetRestaurantSettingsQuery } from '../services/restaurantsApi';
import { formatCurrency, formatCurrencyLocalized, getCurrencySymbol } from '../utils/currencyHelpers';

/**
 * Custom hook to access restaurant currency settings and formatting utilities
 */
export const useCurrency = () => {
  const { data: restaurantSettings, isLoading } = useGetRestaurantSettingsQuery();

  const currencyCode = restaurantSettings?.currency || 'MXN';
  const currencySymbol = getCurrencySymbol(currencyCode);

  /**
   * Format an amount using the restaurant's currency
   */
  const format = (amount: number, decimals: number = 2): string => {
    return formatCurrency(amount, currencyCode, decimals);
  };

  /**
   * Format an amount using localized formatting
   */
  const formatLocalized = (amount: number): string => {
    return formatCurrencyLocalized(amount, currencyCode);
  };

  return {
    currencyCode,
    currencySymbol,
    format,
    formatLocalized,
    isLoading,
  };
};
